import * as React from "react";
import * as ReactDOM from "react-dom";
require("@progress/kendo-theme-material");


interface IPageLoader{
  idValue:string;
}
export const PageLoader = ({idValue}:IPageLoader) => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text"></span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  
  let gridContent = (idValue.indexOf('grid-') > -1 && document) ? document.getElementById(idValue) : null;
  if(gridContent){
  gridContent = gridContent.querySelector(".k-grid-content");
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
  }
  else{
    return null;
  }
    
};